import htmx from "htmx.org";
import {Idiomorph} from "idiomorph/dist/idiomorph.esm.js"

window.htmx = htmx;
window.Idiomorph = Idiomorph;
